export interface PageMetaData {
    /** Заголовок страницы*/
    title?: string;
    /** OpenGraph заголовок страницы*/
    ogTitle?: string;
    /** Описание страницы*/
    description?: string;
    /** OpenGraph описание страницы*/
    ogDescription?: string;
    /** Каноническая ссылка*/
    canonical?: string;
    /** RSS ссылка*/
    rssHref?: string;
    /** RSS заголовок*/
    rssTitle?: string;
    /** Закрыть от индексации */
    noIndex?: boolean;
}

export const DefaultPageMetaData: PageMetaData = {};
